module.exports = "<mat-tab-group [disableRipple]=\"true\" (selectedTabChange)=\"onTabClick($event)\" class=\"tabs\">\n    <mat-tab label=\"Company AE\">\n        <app-company-ae></app-company-ae>\n    </mat-tab>\n\n</mat-tab-group>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/admin/admin.component.html
// module id = ../../../../../src/app/admin/admin/admin.component.html
// module chunks = main